import { clomp } from 'clomp';

export const Icon = clomp.img`
  h-5
  mx-auto
  w-5
`;
